export const localText = {
  errorSubtitle: 'Something went wrong verifying your AWS SSO access.',
  retryButton: 'Try again',
  startingSubtitle: 'Starting sign-in...',
  subtitle: 'Enter this code on the AWS sign-in page to finish signing in.',
  title: 'CDH Operations Hub',
  verifyButton: 'Open AWS sign-in page',
}

export function formatCountdown(seconds: number): string {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}
